<template>
  <section id="card-text-alignment">
    <h3 class="mt-3 mb-2">
      Status disponíveis
    </h3>
    <h5 class="mt-3 mb-2">
      Escolha o status referente as notificações que você quer editar.
    </h5>

    <b-row>
      <!-- center align -->

      <b-col
        v-for="(item, index) in statuses"
        v-if="item.StatusId === 2"
        md="6"
        lg="4"
      >
        <b-card
          :title="item.name"
          class="text-center"
        >
          <b-card-text>
            Escolha esse card para editar o status: {{ item.name }}
          </b-card-text>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            :to="{ name: 'notifications-status-payment', params: { uuid: uuid } }"
          >
            Editar
          </b-button>
        </b-card>
      </b-col>

      <b-col
        v-for="(item, index) in statuses"
        v-if="item.StatusId !== 2 && item.StatusId !== 9"
        md="6"
        lg="4"
      >
        <b-card
          :title="item.name"
          class="text-center"
        >
          <b-card-text>
            Escolha esse card para editar o status: {{ item.name }}
          </b-card-text>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            v-b-modal.modal-select2
            variant="outline-primary"
            :to="{ name: 'notifications-status-edit', params: { status: item.StatusId, uuid: uuid } }"
          >
            Editar
          </b-button>
        </b-card>
      </b-col>

      <!----Aprovado e Integrado---->
      <b-col
        v-for="(item, index) in statuses"
        v-if="item.StatusId == 9 && (uuid =='1e817072-0c2d-45ba-9def-18660bdad469' || uuid == 'e52efd56-d1e8-4d8d-8702-3782c2f6f68e' || uuid == '7a46454c-deed-4393-bdf9-a9480b0cf19f')"
        md="6"
        lg="4"
      >
        <b-card
          :title="item.name"
          class="text-center"
        >
          <b-card-text>
            Escolha esse card para editar o status: {{ item.name }}
          </b-card-text>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            v-b-modal.modal-select2
            variant="outline-primary"
            :to="{ name: 'notifications-status-edit', params: { status: item.StatusId, uuid: uuid } }"
          >
            Editar
          </b-button>
        </b-card>
      </b-col>

    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BButton, BModal, VBModal, BForm, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { codeCounter } from '../forms/form-element/form-textarea/code'
import notificationEdit from './notificationsEdit/notificationEdit.vue'

export default {
  components: {
    BRow, BCol, BCard, BCardText, BButton, BModal, VBModal, BForm, BFormGroup, vSelect, BFormTextarea, notificationEdit,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      value: '',
      maxChar: 500,
      codeCounter,
      statuses: [
        {
          StatusId: 1,
          name: 'Aprovado',
        },
        {
          StatusId: 2,
          name: 'Aguardando Pagamento',
        },
        {
          StatusId: 3,
          name: 'Cancelado',
        },
        {
          StatusId: 4,
          name: 'Transporte',
        },
        {
          StatusId: 5,
          name: 'Entregue',
        },
        {
          StatusId: 6,
          name: 'Boleto Vencido',
        },
        {
          StatusId: 7,
          name: 'Aprovado Parcial',
        },
        {
          StatusId: 8,
          name: 'Carrinho Abandonado',
        },
        {
          StatusId: 9,
          name: 'Aprovado e Integrado',
        },
        {
          StatusId: 11,
          name: 'Cashback',
        }],
      statusName: null,
      statusId: null,
      uuid: this.$route.params.uuid,
    }
  },
  methods: {
    teste(id, name) {
      this.statusId = id
      this.statusName = name
    },
  },
}
</script>
